import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "photo",
  "use": "photo-usage",
  "viewBox": "0 0 65.71 58.71",
  "content": "<symbol viewBox=\"0 0 65.71 58.71\" id=\"photo\"><title>资源 93</title><g id=\"photo_图层_2\" data-name=\"图层 2\"><g id=\"photo_图层_1-2\" data-name=\"图层 1\"><path d=\"M57.49,0H8.21A8.55,8.55,0,0,0,0,8.55v42a8.16,8.16,0,0,0,8.16,8.17H57.55a8.16,8.16,0,0,0,8.16-8.17v0h0V8.55A8.55,8.55,0,0,0,57.49,0ZM4.08,8.55A4.45,4.45,0,0,1,8.21,4.11H57.49a4.45,4.45,0,0,1,4.13,4.45V24.64h0v6.19L48,17.22a2,2,0,0,0-2.83,0L28.08,34.31l-7.59-7.59a2,2,0,0,0-2.83,0L4.11,40.28V24.64h0Zm53,46.07H8.59a4.49,4.49,0,0,1-4.48-4.13V45.84a2,2,0,0,0,.38-.29L19.08,31l7.59,7.59a2,2,0,0,0,2.83,0L46.58,21.46l15,15v14A4.49,4.49,0,0,1,57.12,54.63Z\" /><circle cx=\"13.58\" cy=\"15.63\" r=\"3.5\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/photo.svg
// module id = 5vuh
// module chunks = 264